/* eslint-disable */
import {ChoiceValue} from "data/models/survey/choice-base";

export const DIFFERENTIATORS_CHOICE_LIST: ChoiceValue[] = [
  {"key": "a-money-maker", "value": "a money maker"},
  {"key": "accessible", "value": "accessible"},
  {"key": "best-value", "value": "best value"},
  {"key": "big", "value": "big"},
  {"key": "calming", "value": "calming"},
  {"key": "comfortable", "value": "comfortable"},
  {"key": "community-focused", "value": "community-focused"},
  {"key": "compatible-with-other-systems", "value": "compatible with other systems"},
  {"key": "consistent", "value": "consistent"},
  {"key": "convenient", "value": "convenient"},
  {"key": "customizable", "value": "customizable"},
  {"key": "delicious", "value": "delicious"},
  {"key": "detail-oriented", "value": "detail oriented"},
  {"key": "do-it-yourself", "value": "do-it-yourself"},
  {"key": "easy-to-use", "value": "easy-to-use"},
  {"key": "effective", "value": "effective"},
  {"key": "exciting", "value": "exciting"},
  {"key": "experienced", "value": "experienced"},
  {"key": "fast", "value": "fast"},
  {"key": "full-service", "value": "full service"},
  {"key": "fun", "value": "fun"},
  {"key": "good-for-the-environment", "value": "good for the environment"},
  {"key": "good-looking", "value": "good looking"},
  {"key": "healthy", "value": "healthy"},
  {"key": "less-wasteful", "value": "less wasteful"},
  {"key": "local", "value": "local"},
  {"key": "low-cost", "value": "low cost"},
  {"key": "luxurious", "value": "luxurious"},
  {
    "key": "made-with-best-materials-suppliers-or-ingredients",
    "value": "made with best materials, suppliers or ingredients"
  },
  {"key": "money-saver", "value": "money saver"},
  {"key": "motivational", "value": "motivational"},
  {"key": "multi-featured", "value": "multi-featured"},
  {"key": "personalized", "value": "personalized"},
  {"key": "pleasurable", "value": "pleasurable"},
  {"key": "responsive", "value": "responsive"},
  {"key": "results-driven", "value": "results driven"},
  {"key": "simple", "value": "simple"},
  {"key": "small", "value": "small"},
  {"key": "sophisticated", "value": "sophisticated"},
  {"key": "stress-reducing", "value": "stress reducing"},
  {"key": "technologically-advanced", "value": "technologically advanced"},
  {"key": "the-expert", "value": "the expert"},
  {"key": "time-saver", "value": "time saver"},
  {"key": "trustworthy", "value": "trustworthy"},
  {"key": "unbiased", "value": "unbiased"},
  {"key": "veteran-owned", "value": "veteran owned"},
  {"key": "welcoming", "value": "welcoming"}
];
